<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import {
  StealieButton,
  StealieHeading,
  StealieLink,
  StealieOverline,
  StealieParagraph,
  StealieSpinner,
} from "@get-overalls/fe-stealie";
import SignInLayout from "@/layouts/SignInLayout.vue";
import FormError from "@/components/FormError.vue";
import { useUnlockUser } from "./composables/useUnlockUser";
const route = useRoute();
const unlockToken = route.params.unlockToken;
const { loading, unlockUser, unlockError } = useUnlockUser();

onMounted(async () => {
  await unlockUser(unlockToken);
});
</script>

<template>
  <SignInLayout>
    <div>
      <div>
        <StealieOverline>Unlock Account</StealieOverline>
      </div>
      <div class="col-span-4">
        <StealieHeading size="lg" class="mb-6 text-balance">
          We've got you covered!
        </StealieHeading>
      </div>
      <div v-if="loading">
        <StealieParagraph>
          Please wait while we attempt to unlock your account...
        </StealieParagraph>
        <div class="mt-6 flex h-24 justify-center text-brand-primary-teal-400 sm:w-24">
          <StealieSpinner />
        </div>
      </div>
      <div v-else-if="unlockError">
        <StealieParagraph class="mb-6">
          We were unable to unlock your account. Please check the link you used to unlock
          your account and try again.
        </StealieParagraph>
        <StealieParagraph class="mb-8">
          If you continue to experience issues, please contact
          <StealieLink to="mailto:help@overalls.com" external-link underline
            >Overalls Support</StealieLink
          >.
        </StealieParagraph>
        <FormError :error="unlockError" />
      </div>
      <div v-else>
        <StealieParagraph class="mb-4">
          Your account has been unlocked successfully. You can now sign in with your
          existing credentials, or reset your password if you have forgotten it.
        </StealieParagraph>
        <p class="mb-4">
          <StealieButton :to="{ name: 'SignIn' }">Continue to sign in</StealieButton>
        </p>
        <p class="mb-4">
          <StealieLink :to="{ name: 'ForgotPassword' }" underline>
            Forgot password?
          </StealieLink>
        </p>
      </div>
    </div>
  </SignInLayout>
</template>
